import { earlyAccessCriticalPath } from './earlyAccessCriticalPath';
import { formatMoney } from './lookahead-common';

export const OldSlackDaysFormatter = (activity, gantt) => {
  const slack = activity.totalSlack;
  if (slack === undefined || slack === null || slack === '') {
    return { enFormatSlack: '', otherFormatSlack: '' };
  }
  const daysSlack = gantt.formatter.format(slack);
  const parseSlack = parseFloat(daysSlack);
  const enFormatSlack = formatMoney(parseSlack, '', 2, '.', ',');
  const otherFormatSlack = formatMoney(parseSlack, '', 2, ',', '.');
  return { enFormatSlack, otherFormatSlack };
};

export const slackDaysFormatter = (activity, gantt) => {
  if (earlyAccessCriticalPath()) {
    const slack = activity.totalSlack;
    if (slack === undefined || slack === null || slack === '') {
      return { enFormatSlack: '', otherFormatSlack: '' };
    }
    const parseSlack = parseFloat(slack).toFixed(2);
    const enFormatSlack = parseSlack;
    const otherFormatSlack = parseSlack.replace('.', ',');

    return { enFormatSlack, otherFormatSlack };
  }
  return OldSlackDaysFormatter(activity, gantt);
}; 